import PermissionInfoField from "./permission-info-field";
import PermissionActionField from './permission-action-field';

const PermissionFields = {
    Info: PermissionInfoField,
    Action: PermissionActionField,
};

export default PermissionFields;